import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class FaGraph extends AbstractScatterVisualization {}
